/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Perpetual balance DTO.
 */
export interface PerpetualBalanceDto {
  /**
   * Execution destination
   */
  executionDestination?: PerpetualBalanceDto.ExecutionDestinationEnum;
  /**
   * The total notional value of all your open positions at current market prices
   */
  positionNotional?: number;
  /**
   * The amount of capital you can still deploy for new Perpetual trades
   */
  buyingPower?: number;
  /**
   * Your total funds including unrealized PnL (i.e. collateral - unrealized_pnl)
   */
  balance?: number;
  /**
   * Collateral required to open and support all current positions at the initial margin rate
   */
  initialMarginNotional?: number;
  /**
   * Collateral currently reserved against your open positions
   */
  currentMarginNotional?: number;
  /**
   * Collateral threshold (in USDC) you must maintain to keep positions open
   */
  maintenanceMarginNotional?: number;
  /**
   * Collateral level below which the platform will forcibly close out your positions
   */
  closeOutMarginNotional?: number;
  /**
   * Actual margin rate
   */
  marginOverride?: number;
  /**
   * Timestamp of the balance snapshot
   */
  timestamp?: string;
}
export namespace PerpetualBalanceDto {
  export const ExecutionDestinationEnum = {
    NoOperation: 'NO_OPERATION',
    CoinbasePerpetual: 'COINBASE_PERPETUAL',
    BybitPerpetual: 'BYBIT_PERPETUAL',
  } as const;
  export type ExecutionDestinationEnum = (typeof ExecutionDestinationEnum)[keyof typeof ExecutionDestinationEnum];
}
